import development from "./development";
import local from "./local";
import production from "./production";

export const configByMode = { local, development, production };
